import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DownloadForOfflineOutlinedIcon from '@mui/icons-material/DownloadForOfflineOutlined';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { Button, IconButton, Stack, Typography } from '@mui/material';
import { saveAs } from 'file-saver';
import { FC, useState } from 'react';

import PreviewFileModal from '@components/PreviewFileModal/PreviewFileModal';
import DeleteDocumentModal from '@features/applicationsDocs/components/DeleteDocumentModal/DeleteDocumentModal';
import { ApplicationDocument } from '@features/applicationsDocs/type';
import { borderGrey } from '@styles/colors';
import { medium } from '@styles/fontWeights';
import { LoadingButton } from '@mui/lab';

type ApplicationDocsListItemProps = {
  document: ApplicationDocument;
  applicationId: number;
};

const ApplicationDocsListItem: FC<ApplicationDocsListItemProps> = ({
  document,
  applicationId,
}) => {
  const [selectedFilePath, setSelectedFilePath] = useState<string | null>(null);
  const [selectedDocumentId, setSelectedDocumentId] = useState<number | null>(
    null,
  );
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadFile = async (fileUrl: string | URL | Request, fileName: string | undefined) => {
    setIsDownloading(true);
    try {
      const response = await fetch(fileUrl, {
        method: 'GET',
        headers: {
          // Optionally add headers if neede
        },
      });
      const blob = await response.blob();
      saveAs(blob, fileName);
    } catch (error) {
      console.error('Error downloading the file:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Stack
      spacing={2}
      direction={{ xs: 'column', md: 'row' }}
      justifyContent="space-between"
      alignItems="center"
      sx={{
        p: 3,
        borderRadius: 2,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: borderGrey,
      }}
    >
      <Typography fontWeight={medium} display="flex" alignItems="center">
        <DescriptionOutlinedIcon color="secondary" sx={{ mr: 1 }} />
        {document.file_name}
      </Typography>
      <Stack
        spacing={2}
        direction={{ xs: 'column', sm: 'row' }}
        alignItems="center"
      >
        <Button
          size="small"
          variant="contained"
          color="secondary"
          startIcon={<RemoveRedEyeOutlinedIcon />}
          onClick={() => setSelectedFilePath(document.file_path)}
        >
          Preview
        </Button>
        <LoadingButton
          loading={isDownloading}
          disabled={isDownloading}
          size="small"
          variant="contained"
          color="secondary"
          startIcon={<DownloadForOfflineOutlinedIcon />}
          onClick={() => downloadFile(document.file_path, document.file_name)}
        >
          Download
        </LoadingButton>
        <IconButton onClick={() => setSelectedDocumentId(document.id)}>
          <HighlightOffOutlinedIcon color="error" />
        </IconButton>
      </Stack>

      <PreviewFileModal
        filePath={selectedFilePath}
        handleClose={() => setSelectedFilePath(null)}
        isS3Path
        addS3Path
      />
      <DeleteDocumentModal
        applicationId={applicationId}
        documentId={selectedDocumentId}
        handleClose={() => setSelectedDocumentId(null)}
      />
    </Stack>
  );
};

export default ApplicationDocsListItem;
